<template>
  <div>
    <draggable
      v-model="questions"
      handle=".handle-question"
    >
      <div v-for="(question, index) in questions" :key="index">
        <BlocGabaritQuestion
          :class="activeCssClickedDragIcon ? 'ghost' : ''"
          :key="index"
          :question="question"
          :indexQuestion="index"
        ></BlocGabaritQuestion>
      </div>
    </draggable>
    <AddQuestionButton />
  </div>
</template>

<script>
import BlocGabaritQuestion from '@/components/question/BlocGabaritQuestion'
import AddQuestionButton from '@/components/question/components/AddQuestionButton'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  components: {
    BlocGabaritQuestion,
    draggable,
    AddQuestionButton
  },
  data () {
    return {
      dragDisabled: true,
      activeCssClickedDragIcon: false
    }
  },
  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },
  computed: {
    ...mapGetters(['type_formulaire']),
    questions: {
      get: function () {
        return this.$store.state.question.questions
      },
      set: function (newValue) {
        this.$store.commit('UPDATE_QUESTIONS_OR_SECTIONS_ORDER', {
          type: this.type_formulaire,
          response: newValue
        })
      }
    }
  },
  created () {
    EventBus.$on('clickedDragIcon', this.changeCssClickedDragIcon)
  },
  methods: {
    changeCssClickedDragIcon (value) {
      this.activeCssClickedDragIcon = value
    }
  }
}
</script>
<style scoped>
.ghost:active {
  background: #adadad;
  color: white;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/question/simple/draggable/DraggableFormSimple.vue